import { DanceEventCoHostStatus } from '../../..';

export class ChangeCoHostStatusRequestDto {
  danceManagerId: string;
  status: DanceEventCoHostStatus;
}
